<script>
import MetisMenu from "metismenujs/dist/metismenujs";

export default {
    data() {
        return {
            mostrarPagos:false
        };
    },
    components: {},
    mounted: function () {
        const sidebarLayout = localStorage.getItem('sidebar-layout');
        switch (sidebarLayout) {
            case 'light-sidebar':
                this.lightSidebar();
                break;
            case 'compact-sidebar':
                this.compactSidebar();
                break;
            case 'icon-sidebar':
                this.iconSidebar();
                break;
            case 'colored-sidebar':
                this.coloredSidebar();
                break;
            case 'boxed-layout':
                this.boxedLayout();
                break;
            default:
                document.body.setAttribute("data-sidebar", "dark");
                break;
        }
        // eslint-disable-next-line no-unused-vars
        var menuRef = new MetisMenu("#side-menu");
        var links = document.getElementsByClassName("side-nav-link-ref");
        var matchingMenuItem = null;
        for (var i = 0; i < links.length; i++) {
            if (window.location.pathname === links[i].pathname) {
                matchingMenuItem = links[i];
                break;
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");
            var parent = matchingMenuItem.parentElement;

            /**
             * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
             * We should come up with non hard coded approach
             */
            if (parent) {
                parent.classList.add("mm-active");
                const parent2 = parent.parentElement.closest("ul");
                if (parent2 && parent2.id !== "side-menu") {
                    parent2.classList.add("mm-show");

                    const parent3 = parent2.parentElement;
                    if (parent3) {
                        parent3.classList.add("mm-active");
                        var childAnchor = parent3.querySelector(".has-arrow");
                        var childDropdown = parent3.querySelector(".has-dropdown");
                        if (childAnchor) childAnchor.classList.add("mm-active");
                        if (childDropdown) childDropdown.classList.add("mm-active");

                        const parent4 = parent3.parentElement;
                        if (parent4) parent4.classList.add("mm-show");
                        const parent5 = parent4.parentElement;
                        if (parent5) parent5.classList.add("mm-active");
                    }
                }
            }
        }
    },
    created() {
        axios.get('/api/config').then(response => {
            this.mostrarPagos = response.data.mostrarPagos;
        });
    },
    methods: {
        defaultSidebar() {
            localStorage.setItem("sidebar-layout", 'default-sidebar');
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.removeAttribute("data-topbar", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        lightSidebar() {
            localStorage.setItem("sidebar-layout", 'light-sidebar');
            document.body.setAttribute("data-topbar", "dark");
            document.body.removeAttribute("data-sidebar");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        compactSidebar() {
            localStorage.setItem("sidebar-layout", 'compact-sidebar');
            document.body.setAttribute("data-sidebar-size", "small");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.classList.remove("vertical-collpsed");
            document.body.removeAttribute("data-topbar", "dark");
        },
        iconSidebar() {
            localStorage.setItem("sidebar-layout", 'icon-sidebar');
            document.body.setAttribute("data-keep-enlarged", "true");
            document.body.classList.add("vertical-collpsed");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-topbar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
        },
        boxedLayout() {
            localStorage.setItem("sidebar-layout", 'boxed-layout');
            document.body.setAttribute("data-keep-enlarged", "true");
            document.body.classList.add("vertical-collpsed");
            document.body.setAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar", "colored");
            document.body.setAttribute("data-sidebar", "dark");
            document.body.removeAttribute("data-topbar", "dark");
        },
        coloredSidebar() {
            localStorage.setItem("sidebar-layout", 'colored-sidebar');
            document.body.setAttribute("data-sidebar", "colored");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.removeAttribute("data-sidebar-size", "small");
            document.body.classList.remove("vertical-collpsed");
        },
        crear(tipo){
            localStorage.setItem("usuario", tipo);
            window.location.href = "/web/configuracion/crearusuario";
        }
    }
};
</script>

<template>
<!-- ========== Left Sidebar Start ========== -->

<!--- Sidemenu -->
<div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
        <li class="menu-title">Menu</li>
        <li>
            <a href="/" class="side-nav-link-ref">
                <i class="bx bx-home-circle"></i>
                <span>Inicio</span>
            </a>
        </li>
        <li v-if="['admin', 'superadmin'].includes(String(user.rol || '').trim().toLowerCase()) || Number(user.id) === 1">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-user-circle"></i>
                <span>Usuarios</span>
            </a>
            <ul class="sub-menu" aria-expanded="true">
                <li>
                    <a href="/web/configuracion/usuarios"><i class="bx bx-user mr-1"></i>Ver Usuarios</a>
                </li>
                <li>
                    <a href="/web/configuracion/laborantes"><i class="bx bx-id-card mr-1"></i>Ver Laborantes</a>
                </li>
                <li>
                    <a href="/web/configuracion/crearusuario"><i class="bx bx-user-plus mr-1"></i>Agregar Usuario</a>
                </li>
                <li>
                    <a href="javascript: void(0);" class="has-arrow"><i class="bx bx-transfer-alt mr-1"></i>Usuarios Reemplazo</a>
                    <ul class="sub-menu" aria-expanded="true">
                        <li>
                            <a href="/web/invitado/listado"><i class="bx bx-list-ul mr-1"></i>Listado</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
        <!-- <li v-if="user.rol=='Admin'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-share-alt"></i>
                <span>Usuarios</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/usuarios">Ver Usuarios</a>
                </li>
                <li>
                    <a href="/web/configuracion/laborantes">Ver Laborantes</a>
                </li>
                <li>
                    <a href="/web/configuracion/crearusuario">Agregar Usuario</a>
                </li>
            </ul>
        </li> -->
        <li v-if="user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-buildings"></i>
                <span>Colegios</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/colegios"><i class="bx bx-search-alt mr-1"></i>Buscar Colegio</a>
                </li>
                <li>
                    <a href="/web/configuracion/colegios_descargar"><i class="bx bx-download mr-1"></i>Descargar Colegios</a>
                </li>
            </ul>
        </li>
        <li v-if="user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-calendar"></i>
                <span>Eventos</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/configuracion/eventos"><i class="bx bx-search-alt mr-1"></i>Buscar Eventos</a>
                </li>
                <li>
                    <a href="/web/configuracion/crearevento"><i class="bx bx-calendar-plus mr-1"></i>Crear Evento</a>
                </li>
                <li>
                    <a href="/web/configuracion/eventos_descargar"><i class="bx bx-download mr-1"></i>Descargar Eventos</a>
                </li>
                <li v-if="user.rol=='Admin'">
                    <a href="/web/configuracion/emailseventos"><i class="bx bx-envelope mr-1"></i>Correos enviados</a>
                </li>
            </ul>
        </li>
        <!-- <li v-if="mostrarPagos"> -->
        <li v-if="user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-credit-card"></i>
                <span>Pagos</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/laborantes/agregarapoyo"><i class="bx bx-user-plus mr-1"></i>Agregar laborante apoyo oficina</a>
                </li>
                <li>
                    <a href="/web/laborantes/agregarsalida"><i class="bx bx-walk mr-1"></i>Agregar laborante salida por actividades</a>
                </li>
                <li>
                    <a href="/web/laborantes/apago"><i class="bx bx-list-ul mr-1"></i>Listado Pago Laborantes</a>
                </li>
                <li v-if="user.rol=='Admin' || user.rol=='Supervisor'">
                    <a href="/web/laborantes/pagos"><i class="bx bx-wallet mr-1"></i>Pagos Laborantes</a>
                </li>
                <li v-if="user.rol=='Admin'">
                    <a href="/web/laborantes/porpagar"><i class="bx bx-time-five mr-1"></i>Por Pagar</a>
                </li>
                <li v-if="user.rol=='Admin'">
                    <a href="/web/laborantes/todospagos"><i class="bx bx-history mr-1"></i>Historial de pagos</a>
                </li>
                <li v-if="user.rol=='Admin'">
                    <a href="/web/laborantes/valorespago"><i class="bx bx-money mr-1"></i>Valores Pagos</a>
                </li>
            </ul>
        </li>
        <li v-if="user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-receipt"></i>
                <span>Gastos asociados</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li v-if="user.rol=='Admin'|| user.rol=='Supervisor'">
                    <a href="/web/gastos/ver"><i class="bx bx-search-alt mr-1"></i>Revisión Gastos</a>
                </li>
                <li>
                    <a href="/web/gastos/historial"><i class="bx bx-history mr-1"></i>Historial de Gastos</a>
                </li>
            </ul>
        </li>
        <li>
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-file"></i>
                <span>Digitalizador</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/digitalizar/asociar"><i class="bx bx-link-alt mr-1"></i>Asociar evento</a>
                </li>
                <li v-if="Number(user.id) === 1 || String(user.rol || '').trim().toLowerCase() === 'superadmin'">
                    <a href="/web/digitalizar/respuestas"><i class="bx bx-scan mr-1"></i>Escanear respuestas</a>
                </li>
                <li v-if="user.rol=='Admin'">
                    <a href="/web/digitalizar/listado"><i class="bx bx-list-ul mr-1"></i>Listado</a>
                </li>
                <li v-if="Number(user.id)===1">
                    <a href="/web/digitalizar/estadoscrm"><i class="bx bx-pulse mr-1"></i>Estados CRM</a>
                </li>
                <li v-if="Number(user.id)===1">
                    <a href="/web/digitalizar/metricascrm"><i class="bx bx-line-chart mr-1"></i>Metricas CRM</a>
                </li>
                <li v-if="Number(user.id)===1">
                    <a href="/web/digitalizar/uso"><i class="bx bx-bar-chart-alt-2 mr-1"></i>Uso digitalizadores</a>
                </li>
            </ul>
        </li>
        <li v-if="user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-clipboard"></i>
                <span>Evaluaciones</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li v-if="user.rol=='Admin' || user.cargo=='Supervisor'">
                    <a href="/web/evaluar/coordinador"><i class="bx bx-check-square mr-1"></i>Evaluar Coordinador</a>
                </li>
                <li>
                    <a href="/web/evaluar/laborante"><i class="bx bx-check-square mr-1"></i>Evaluar Laborante</a>
                </li>
                <li>
                    <a href="/web/evaluaciones/coordinadores"><i class="bx bx-clipboard mr-1"></i>Evaluaciones Coordinadores</a>
                </li>
                <li>
                    <a href="/web/evaluaciones/laborantes"><i class="bx bx-clipboard mr-1"></i>Evaluaciones Laborantes</a>
                </li>
            </ul>
        </li>
        <li v-if="user.rol=='Admin' && user.rol!='Laborante'">
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-cog"></i>
                <span>Configuración</span>
            </a>
            <ul class="sub-menu" aria-expanded="false">
                <li>
                    <a href="/web/actualizacion/usuarioscolegios"><i class="bx bx-user-check mr-1"></i>Actualizar usuarios-colegios</a>
                </li>
                <li>
                    <a href="/web/actualizacion/colegios"><i class="bx bx-buildings mr-1"></i>Actualizar colegios</a>
                </li>
                <li v-if="Number(user.id)===1">
                    <a href="/web/configuracion/colacrm"><i class="bx bx-pulse mr-1"></i>Monitoreo cola CRM</a>
                </li>
            </ul>
        </li>
        <!-- <li>
            <a href="javascript: void(0);" class="has-arrow">
                <i class="bx bx-share-alt"></i>
                <span>Multi Level</span>
            </a>
            <ul class="sub-menu" aria-expanded="true">
                <li>
                    <a href="javascript: void(0);">Level 1.1</a>
                </li>
                <li>
                    <a href="javascript: void(0);" class="has-arrow">Level 1.2</a>
                    <ul class="sub-menu" aria-expanded="true">
                        <li>
                            <a href="javascript: void(0);">Level 2.1</a>
                        </li>
                        <li>
                            <a href="javascript: void(0);">Level 2.2</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </li> -->
    </ul>
</div>
<!-- Sidebar -->
</template>
